import { useContext, useEffect, useRef, useState } from "react";
import activoContext from "../../context/activoContex/activoContex";
import nivel1Context from "../../context/nivel1Context/nivel1Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown, faAngleDoubleUp, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";

import './ContextualMenu.css';
import nivel2Context from "../../context/nivel2Context/nivel2Context";
import nivel3Context from "../../context/nivel3Context/nivel3Context";
import nivel4Context from "../../context/nivel4Context/nivel4Context";
import nivel5Context from "../../context/nivel5Context/nivel5Context";
import Swal from "sweetalert2";

const activoOrLevel = ['Nivel1','Nivel2','Nivel3','Nivel4','Nivel5','Activo'];
const activo = ['Activo'];

const ContextualMenu = ({showContextualMenu, setShowContextualMenu, handleDuplicate, handleDelete, handleDisable, setTreeDataActivo, setIsHoveredBarByFlag}) => {

    const ref = useRef();

    const {updatePositionActivo} = useContext(activoContext);
    const {updatePositionLv1} = useContext(nivel1Context);
    const {updatePositionLv2} = useContext(nivel2Context);
    const {updatePositionLv3} = useContext(nivel3Context);
    const {updatePositionLv4} = useContext(nivel4Context);
    const {updatePositionLv5} = useContext(nivel5Context);

    const [pos,setPos] = useState({x: -9999, y: -9999});

    const handlePositionToUpdate = (type, updates) => {
        switch(type){
            case 'Nivel1':
                updatePositionLv1(updates);
                break;
            case 'Nivel2':
                updatePositionLv2(updates);
                break;
            case 'Nivel3':
                updatePositionLv3(updates);
                break;
            case 'Nivel4':
                updatePositionLv4(updates);
                break;
            case 'Nivel5':
                updatePositionLv5(updates);
                break;
            case 'Activo':
                updatePositionActivo(updates);
                break;
        }
    }

    //Actualizaran directamente activoList del contexto, primero modificando el valor en el frontend y luego el valor en el backend.
    //Backend debera recuperar los activos ahora por position, campo que sera creado primero basandose en los indices del array y luego se ira configurando por el usuario.
    const handleMoveUpAct = () => {
        let levels = showContextualMenu.brothers ?? [];
        let index = levels.findIndex(c => c._id == showContextualMenu.nodeId);
        if(index == 0) return;
        else{
            let positionToSet2 = (levels[index-1].position ?? 1) + 1; //El que estaba arriba y ahora va abajo.
            let positionToSet = positionToSet2 - 1; //El que sube.
            let idToSet2 = levels[index-1]._id;
            handlePositionToUpdate(showContextualMenu.type, [{_id: showContextualMenu.nodeId, position: positionToSet}]);
            handlePositionToUpdate(levels[index-1].type,[{_id: idToSet2, position: positionToSet2}]);
        }
    }
    const handleMoveDownAct = () => {
        let levels = showContextualMenu.brothers ?? [];
        let index = levels.findIndex(c => c._id == showContextualMenu.nodeId);
        if(index == levels.length - 1) return;
        else{
            let positionToSet2 = levels[index + 1].position - 1; //El que estaba arriba y ahora va abajo.
            let positionToSet = positionToSet2 + 1; //El que sube.
            let idToSet2 = levels[index + 1]._id;
            handlePositionToUpdate(showContextualMenu.type, [{_id: showContextualMenu.nodeId, position: positionToSet}]);
            handlePositionToUpdate(levels[index+1].type, [{_id: idToSet2, position: positionToSet2}]);
        }
    }
    const handleMoveToTopAct = () => {
        let levels = showContextualMenu.brothers ?? [];
        let typeNotActivo = null;
        let index = levels.findIndex(c => c._id == showContextualMenu.nodeId);
        if(index == -1 || index == 0) return;
        else{
            let arrayToUpdateLevels = [];
            let arrayToUpdateActivos = [];
            for(const item of levels){
                if(item.type != 'Activo'){
                    if(!typeNotActivo) typeNotActivo = item.type;
                    if(item.position <= levels[index].position && item._id != showContextualMenu.nodeId){
                        arrayToUpdateLevels.push({_id: item._id, position: item.position + 1});
                    }else if(item._id == showContextualMenu.nodeId){
                        arrayToUpdateLevels.push({_id: item._id, position:1});
                    }
                }else{
                    if(item.position <= levels[index].position && item._id != showContextualMenu.nodeId){
                        arrayToUpdateActivos.push({_id: item._id, position: item.position + 1})
                    }else if(item._id == showContextualMenu.nodeId){
                        arrayToUpdateActivos.push({_id: item._id, position:1});
                    }
                }
            }
            if(arrayToUpdateLevels.length > 0 && typeNotActivo) handlePositionToUpdate(typeNotActivo, arrayToUpdateLevels);
            if(arrayToUpdateActivos.length > 0) handlePositionToUpdate('Activo', arrayToUpdateActivos);
        }
    }
    const handleMoveToBottomAct = () => {
        let levels = showContextualMenu.brothers ?? [];
        let typeNotActivo = null;
        let index = levels.findIndex(c => c._id == showContextualMenu.nodeId);
        
        if(index == -1 || index == levels.length - 1) return;
        else{
            let arrayToUpdateLevels = [];
            let arrayToUpdateActivos = [];
            
            for(const item of levels){
                if(item.type != 'Activo'){
                    if(!typeNotActivo) typeNotActivo = item.type;
                    if(item.position >= levels[index].position && item._id != showContextualMenu.nodeId){
                        arrayToUpdateLevels.push({_id: item._id, position: item.position - 1});
                    }else if(item._id == showContextualMenu.nodeId){
                        arrayToUpdateLevels.push({_id: item._id, position: levels[levels.length - 1].position + 1});
                    }
                }else{
                    if(item.position <= levels[index].position && item._id != showContextualMenu.nodeId){
                        arrayToUpdateActivos.push({_id: item._id, position: item.position - 1})
                    }else if(item._id == showContextualMenu.nodeId){
                        arrayToUpdateActivos.push({_id: item._id, position: levels[levels.length - 1].position + 1});
                    }
                }
            }
            
            if(arrayToUpdateLevels.length > 0 && typeNotActivo) handlePositionToUpdate(typeNotActivo, arrayToUpdateLevels);
            if(arrayToUpdateActivos.length > 0) handlePositionToUpdate('Activo', arrayToUpdateActivos);
        }
    }
	
     useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowContextualMenu(null);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(()=>{
        const menu = ref.current;
        if(!menu) return;

        const { innerHeight, innerWidth } = window;
        const rect = menu.getBoundingClientRect();

        let newX = showContextualMenu.x;
        let newY = showContextualMenu.y;

        if(newY + rect.height > innerHeight){
            newY = newY - rect.height;
        }

        setPos({x: newX, y: newY});

    },[showContextualMenu]);

    const handleTry = ( ) => {
        Swal.fire("OSSSS")
        .finally(()=>setIsHoveredBarByFlag(true));
    }

   return <div ref={ref} className='contextualMenuContainer' style={{ top: pos.y, left: pos.x }}>
        {(activoOrLevel.includes(showContextualMenu.type))  && <h6 onClick={handleMoveToTopAct}>Mover Arriba del todo<FontAwesomeIcon className="sortIcon" icon={faAngleDoubleUp}/></h6>}
      
        {(activoOrLevel.includes(showContextualMenu.type)) && <hr/>}
      
        {(activoOrLevel.includes(showContextualMenu.type))  && <h6 onClick={handleMoveUpAct}>Mover uno Arriba <FontAwesomeIcon className="sortIcon" icon={faSortUp}/></h6>}
      
        {(activoOrLevel.includes(showContextualMenu.type)) && <hr/>}
      
        {(activoOrLevel.includes(showContextualMenu.type))  && <h6 onClick={handleMoveDownAct}>Mover uno Abajo<FontAwesomeIcon className="sortIcon" icon={faSortDown}/></h6>}
      
        {(activoOrLevel.includes(showContextualMenu.type)) && <hr/>}
      
        {(activoOrLevel.includes(showContextualMenu.type))  && <h6 onClick={handleMoveToBottomAct}>Mover Abajo del todo<FontAwesomeIcon className="sortIcon" icon={faAngleDoubleDown}/></h6>}
      
        {(['Nivel1','Activo'].includes(showContextualMenu.type)) && <hr/>}
      
        {showContextualMenu.type == 'Nivel1' && <h6 onClick={handleDuplicate}>DUPLICAR</h6>} 
      
        {(activo.includes(showContextualMenu.type)) && <h6 onClick={handleDisable}>{showContextualMenu.deBaja ? 'HABILITAR' : 'DESHABILITAR'}</h6>}
        
        {(activoOrLevel.includes(showContextualMenu.type)) && <hr/>}
        
        {(activoOrLevel.includes(showContextualMenu.type)) && <h6 onClick={handleDelete}>ELIMINAR</h6>}
    </div>

}

export default ContextualMenu;